<template>
    <div id="page">
        <div class="flex pad14 alc" id="toolH">
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    clearable
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>
            <el-select  @change="changeData($event,'gs')" @clear="clearsearch('gs')" class="marr4" v-model="vc_gsname" size="mini" clearable filterable placeholder="请选择公司">
                <el-option
                        v-for="item in compsData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-select  @change="changeData($event,'kh')" @clear="clearsearch('kh')" class="marr4" v-model="vc_khname" size="mini" clearable filterable placeholder="请选择客户">
                <el-option
                        v-for="item in khData"
                        :key="item.i_khid"
                        :label="item.vc_khname"
                        :value="item.i_khid">
                </el-option>
            </el-select>
            <el-input  class="marr4" style="width: 280px"  v-model="vc_search" placeholder="输入要搜索的品名" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="savejp({},'pl')">{{'批量保存'}}</el-button>
            <el-button :class="baseerp+'btn'"  size="mini" type="primary" @click="submitjp({},'pl')">{{'批量提交'}}</el-button>
        </div>
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @selection-change="handleSelectionChange"
                :row-key="row => row.i_subId">
            <el-table-column
                    align="center"
                    type="selection"
                    :reserve-selection="true"
                    :selectable="checkSelectable"
                    width="50">
            </el-table-column>
            <el-table-column
                    type="index"
                    label=""
                    show-overflow-tooltip
                    width="55">
            </el-table-column>
            <!--<el-table-column
                    prop="i_subId"
                    :label="'ID'"
                    show-overflow-tooltip
                    width="70">
            </el-table-column>-->
            <el-table-column
                    prop="vc_gsname"
                    :label="'公司'"
                    show-overflow-tooltip
                    min-width="135">
            </el-table-column>
            <el-table-column
                    prop="vc_khname"
                    :label="'客户'"
                    show-overflow-tooltip
                    min-width="135">
            </el-table-column>
            <el-table-column
                    prop="vc_pzname"
                    :label="'品名'"
                    show-overflow-tooltip
                    min-width="250">
            </el-table-column>
            <el-table-column
                    prop="f_list_price"
                    :label="'挂牌价'"
                    width="100px"
                    show-overflow-tooltip
                    align="right">
            </el-table-column>
            <el-table-column
                    prop="f_open_price"
                    :label="'揭牌价'"
                    width="130px"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-input-number :disabled="scope.row.i_open_price_state==1" @change="inprice(tableData,scope.$index,scope.row)"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_open_price" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    :label="'挂牌时间'"
                    show-overflow-tooltip
                    width="98">
            </el-table-column>
            <el-table-column
                    prop="dt_open_price_createtime"
                    :label="'揭牌时间'"
                    show-overflow-tooltip
                    width="98">
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    :label="'挂牌录入人'"
                    show-overflow-tooltip
                    width="98">
            </el-table-column>
            <el-table-column
                    prop="vc_open_price_lruname"
                    :label="'揭牌录入人'"
                    show-overflow-tooltip
                    width="98">
            </el-table-column>
            <el-table-column
                    prop="dt_starttime"
                    :label="'开始时间'"
                    show-overflow-tooltip
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="dt_endtime"
                    :label="'结束时间'"
                    show-overflow-tooltip
                    width="150">
            </el-table-column>
            <el-table-column
                    width="120"
                    :label="$t('form_operate')"
                    fixed='right'>
                <template slot-scope="scope">
                    <el-button v-if="scope.row.i_open_price_state==null||scope.row.i_open_price_state==0"  type="text" size="small" @click="savejp(scope.row,'singe')">{{'保存'}}</el-button>
                    <el-button v-if="scope.row.i_open_price_state==0"  type="text" size="small" @click="submitjp(scope.row,'singe')" >{{'提交'}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <el-dialog
                :class="baseerp+'div'"
                width="500px"
                title="确认提交揭牌"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="cancelDialog"
                v-if="dialogVisible"
                :append-to-body="true">
            <div v-for="item in subData">
                <span>{{'挂牌价 '+item.f_list_price}}</span>
                <span>{{'揭牌价 '+item.f_open_price}}</span>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">
                <el-button type="primary" @click="suredata" :class="baseerp+'btn'" size="mini" >确认</el-button>
                <el-button @click="cancelDialog" size="mini">取消</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    export default {
        components: {},
        data() {
            return {
                maxDialogHeight: 0,
                tableHeight:0,
                tableData:[{}],
                multipleSelection:[],
                baseerp:"",
                file_root:"",
                mid:0,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                title:'',
                dialogVisible:false,
                loading:false,
                subData:[],
                gosave:false,
                compsData:[],
                khData:[],
                i_gsid:null,
                vc_gsname:'',
                i_khid:null,
                vc_khname:'',
                kh_gsid:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                vc_search:'',
            }
        },
        watch: {
        },
        activated(){
        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root = file_root;
            this.getList();
            this.getCompanyList();
            this.getkhlist();

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setDialogHeight);
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight;
                const otherHeight =230;
                this.tableHeight = window.innerHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
            },
            checkSelectable(row, index) {
                if (row.i_open_price_state != 1) return true;
            },
            inprice(data,index,row){
                if(row.f_open_price <= 0){
                    row.f_open_price = 0;
                    this.$set(data,index,row);
                    this.$message.error('挂牌价不可小于等于0');
                    this.refreshTable();
                    return ;
                }
                this.gosave=true;
                this.$set(data,index,row);
                const idx = this.multipleSelection.findIndex(item => item.i_subId === row.i_subId);
                if (idx >= 0) this.$set(this.multipleSelection, idx, { ...row });

            },
            savejp(row,type){
                let arr=[];
                if(type=='singe'){
                    if(!row.f_open_price){this.$message.error('揭牌价不能为空/0！');return;}
                    let map={
                        i_id:row.i_subId,
                        f_list_price:row.f_list_price,
                        f_open_price:row.f_open_price,
                        i_open_price_lruid:sessionStorage.getItem('userid'),
                        vc_open_price_lruname:sessionStorage.getItem("lruname"),
                    }
                    arr.push(map);
                }
                if(type=='pl'){
                    if(this.multipleSelection.length==0){this.$message.error('请选择要保存或提交的揭牌数据');return;}
                    let nojpj = this.multipleSelection.some(item=>!item.f_open_price)
                    if(nojpj){this.$message.error('揭牌价不能为空/0！');return;}
                    this.multipleSelection.map(item=>{
                        let map={};
                            map.i_id=item.i_subId;
                            map.f_list_price=item.f_list_price;
                            map.f_open_price=item.f_open_price;
                            map.i_open_price_lruid=sessionStorage.getItem('userid');
                            map.vc_open_price_lruname=sessionStorage.getItem("lruname");
                        arr.push(map)
                    })
                }
                this.saveorupdateOpenPrice('save',arr);
            },
            submitjp(row,type){
                if(this.gosave==true){this.$message.error('修改数据后请先保存！');return;}
                let arr=[];
                if(type=='singe'){
                    if(row.i_open_price_state==null){this.$message.error('请保存后再提交');return;}
                    let map={
                        i_id:row.i_subId,
                        f_list_price:row.f_list_price,
                        f_open_price:row.f_open_price,
                        i_gsid:row.i_gsid,
                        i_khid:row.i_khid,
                        vc_khname:row.vc_khname,
                        i_pzid:row.i_pzid,
                        dt_starttime:row.dt_starttime,
                        dt_endtime:row.dt_endtime,
                    }
                    arr.push(map);
                    this.$alert(
                        `<ul>
                            <li>挂牌价：${row.f_list_price}</li>
                            <li>揭牌价：${row.f_open_price}</li>
                        </ul>`
                    , this.$t('是否确认提交'), {
                        dangerouslyUseHTMLString: true,
                        type:'warning',
                        confirmButtonText: this.$t('button_sure'),
                        cancelButtonText: this.$t('button_cancel'),
                    }).then(()=>{
                        //this.saveorupdateOpenPrice('submit',arr);
                        this.checkJp('submit',arr);
                    }).catch(() => {
                    });
                }
                if(type=='pl'){
                    //console.log('this.multipleSelection---',this.multipleSelection)
                    if(this.multipleSelection.length==0){this.$message.error('请选择要保存或提交的揭牌数据');return;}
                    let nosave = this.multipleSelection.some(item=>item.i_open_price_state==null)
                    if(nosave){this.$message.error('存在未保存的揭牌价,请保存后再提交');return;}
                    this.multipleSelection.map(item=>{
                        let map={};
                        map.i_id=item.i_subId;
                        map.f_list_price=item.f_list_price;
                        map.f_open_price=item.f_open_price;
                        map.i_gsid=item.i_gsid;
                        map.i_khid=item.i_khid;
                        map.vc_khname=item.vc_khname;
                        map.i_pzid=item.i_pzid;
                        map.dt_starttime=item.dt_starttime;
                        map.dt_endtime=item.dt_endtime;
                        arr.push(map)
                    })
                    this.subData = arr;
                    this.dialogVisible=true;
                }

            },
            suredata(){
                this.dialogVisible=false;
                //this.saveorupdateOpenPrice('submit',this.subData);
                this.checkJp('submit',this.subData);
            },
            cancelDialog(){this.dialogVisible=false},
            async saveorupdateOpenPrice(type,arr) {
                this.loading = true;
                let param1 = {
                    i_mid: this.mid,
                    priceRecordSubs:arr,
                };
                let param2 = {
                    i_mid: this.mid,
                    i_state:1,
                    priceRecordSubs:arr,
                };
                let res;
                if(type=='save')res = await API.saveOpenPrice(param1);
                if(type=='submit')res = await API.updateOpenPriceState(param2);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.loading = false;
                    this.gosave = false;
                    this.multipleSelection=[];
                    this.tableData.map((item,index)=>{
                        this.$refs.table.toggleRowSelection(this.tableData[index],false)
                    })
                    if(type=='save'){
                        arr.forEach(key=>{
                            const idx =this.tableData.findIndex(item=> item.i_subId == key.i_id);
                            if(idx!=-1){
                                this.$set(this.tableData[idx],'f_list_price',key.f_list_price)
                                this.$set(this.tableData[idx],'i_open_price_state',0)
                            }
                        })
                    }else{
                        //this.currentPage=1;
                        this.tableData=[];
                        this.getList()
                    }
                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            async checkJp(type,arr) {
                this.loading = true;
                let param = {
                    i_mid: this.mid,
                    priceRecordSubs:arr,
                };
                let res = await API.isCommitOpenPrice(param);
                if (res.code == 1) {
                    //this.$message.success(res.message);
                    this.loading = false;
                    this.saveorupdateOpenPrice(type,arr);
                } else if (res.code == -2) {
                    this.loading = false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading = false;
                    this.$message.error(res.message);
                }
            },
            handleSelectionChange(currentSelectedRows) {
                this.multipleSelection=currentSelectedRows;
                /*currentSelectedRows.forEach(row => {
                    const idx = this.multipleSelection.findIndex(item => item.i_subId === row.i_subId);
                    if(idx==-1)this.multipleSelection.push(Object.assign({}, row))
                })
                this.tableData.forEach(row => {
                    const idx = this.multipleSelection.findIndex(item => item.i_subId === row.i_subId);
                    if(idx!=-1){
                        console.log('row',row)
                        row.f_open_price=0;
                        this.multipleSelection.splice(idx, 1)
                    }
                })*/
                //console.log( 'this.multipleSelection', this.multipleSelection)
            },
            issameid(gs,kh){
                if(gs==kh){this.$message.error('公司和客户不能为同一个');return true;}
                return false;
            },
            changeData(e,type){
                if (type == 'kh') {
                    this.i_khid = e;
                    let choo = this.khData.filter(item => {
                        return item.i_khid == e
                    });
                    if (choo.length > 0) {
                        this.vc_khname = choo[0].vc_khname;
                        this.kh_gsid = choo[0].i_gsid;
                    } else {
                        this.vc_khname = '';
                        this.kh_gsid = 0;
                    }
                    let thesame = this.issameid(this.i_gsid,this.kh_gsid)
                    if(thesame){
                        this.i_khid = null;
                        this.vc_khname = '';
                    }
                }
                if(type=='gs'){
                    this.i_gsid=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_gsname=choo[0].vc_name;
                    }else{
                        this.vc_gsname='';
                    }
                    let thesame = this.issameid(this.i_gsid,this.kh_gsid)
                    if(thesame){
                        this.i_gsid = null;
                        this.vc_gsname = "";
                    }
                }
            },
            gosearch(){
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if (type == 'kh') {
                    this.i_khid = null;
                    this.vc_khname = '';
                    this.kh_gsid = 0;
                }
                if (type == 'gs') {
                    this.i_gsid = null;
                    this.vc_gsname = "";
                }
                if(type=='sou'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                //this.getList();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            async getList(){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    //'i_state':this.i_state,
                    "i_gsid": this.i_gsid,
                    'i_khid':this.i_khid,
                    'dt_starttime':this.dt_startdate?this.dt_startdate+' 00:00:00':'',
                    'dt_endtime':this.dt_enddate?this.dt_enddate+' 23:59:59':'',
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                };
                let res = await API.list(param);
                if (res.code==1){
                    this.tableData=res.data;
                    this.tableTotal=res.total;
                    this.loading=false;
                    this.setDialogHeight();
                    window.addEventListener('resize', this.setDialogHeight);
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            async getCompanyList() {
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getkhlist() {
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.khData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                //this.currentPage=1;
                //this.tableData=[];
                //this.getList();
            },
        },
    }
</script>

<style  lang="scss" scoped>
    /deep/.el-dialog__body{
        max-height: 400px !important;
        overflow-y: auto !important;
    }
    /deep/ .el-table__header-wrapper th .cell .el-checkbox {
        display: none;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .pad14{
        padding: 4px;
    }
    .alc{
        align-items: center;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }

</style>